/**
 * @class PromoBottom
 */
class PromoBottom {
    /**
     * @param {jQuery} $banner
     * @param {StorageHandler} storageHandler
     */
    constructor($banner, storageHandler) {
        this.$banner = $banner;
        this.storageHandler = storageHandler;
        this.$closeButton = $banner.find('.promo-bottom__close');
    }

    /**
     * @returns {PromoBottom}
     */
    init() {
        this.showBanner().initClose();

        return this;
    }

    /**
     * @returns {PromoBottom}
     */
    showBanner() {
        if (this.storageHandler.sessionRetrieve(PromoBottom.getStorageKey())) {
            return this;
        }

        setTimeout(this.$banner.fadeIn.bind(this.$banner), 1000);

        return this;
    }

    /**
     * @returns {PromoBottom}
     */
    initClose() {
        this.$closeButton.on('click', this.onClose.bind(this));

        return this;
    }

    /**
     * @returns {PromoBottom}
     */
    onClose() {
        this.$banner.hide();
        this.storageHandler.sessionStore(PromoBottom.getStorageKey(), true);

        return this;
    }

    /**
     * @returns {string}
     */
    static getStorageKey() {
        return 'promo-banner-shown';
    }
}

export default PromoBottom;